import React from "react";
import { useEffect } from 'react';
import { useState } from "react";
//import EnterAnimation from "./components/enter-animation";
import CatCursor from "./components/cat-cursor";
import './index.css';
import OpenAbout from "./components/about-me";
import OpenProjects from "./components/projects";
import TaskBar from "./components/task-bar";
import mow from "./task_bar.png"
import startButton from "./start_task.png"
import resumeImg from "./resume_img.png"
import projImg from "./projects_img.png"
import contImg from "./newCont_img.png"



function App() {
  useEffect(() => {
    document.body.classList.add('no-scroll');
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, []);
  const [showProjects, setShowProjects] = useState(false);
// bello
  return (
    <div className="App">
      <CatCursor />
      <OpenAbout />

       
      <div className="task-container">
        <img src={mow} className="task-bar" />
        <img src={startButton} className="task-bar-content" />
      </div>

      <div className="desktop-icon-container">
        <a href="https://chauphan.me/CPhan_NewGradResumeSite.pdf" target="_blank" rel="noopener noreferrer">
          <img src={resumeImg} className="desktop-icon" />
        </a>
        <img
          src={projImg}
          className="proj-icon"
          onClick={() => setShowProjects(true)}
        />
        <a
          href="mailto:chauuuphan@gmail.com"
          target="_blank"
          rel="noopener noreferrer" >
          <img src={contImg} className="contact-icon" />
        </a>
      </div>

      {showProjects && <OpenProjects />}
      
    </div>

  );
}

export default App;
